import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-duplicate-icon',
  templateUrl: './general-duplicate.component.html'
})
export class GeneralDuplicateComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
